module.exports = __webpack_public_path__ + "img/ft-full-screen.08173284.svg";